@let dataSource = vm().dataSource;

@if ((dataSource && dataSource?.length) || (vm().isLoading && !dataSource)) {
  @let hasData = !!dataSource && !!dataSource?.length;

  <app-table [dataSource]="dataSource && dataSource.length ? dataSource : loadingSkeletonRows" keyProperty="id">
    <app-table-cell-sortable-header
      *appTableCellHeader="let data; key: 'site'; cellWidth: severityColumnIsShown() ? '15%' : '20%'"
      [title]="'shared.alerting-table.site' | translate"
      [sortDirection]="vm().sortProperty === AlertingTableSortPropertyStoreModelEnum.Site ? vm().sortDirection : undefined"
      (sortClick)="onSortClick(AlertingTableSortPropertyStoreModelEnum.Site, $event)"
    ></app-table-cell-sortable-header>

    <div *appTableCell="let data; key: 'site'; dataSource: dataSource">
      @if (hasData) {
        @if (data.siteId) {
          <a [routerLink]="[RouteSegment.Root, RouteSegment.Sites, data.siteId, RouteSegment.Overview]">
            <app-table-view-link [label]="data.siteName" />
          </a>
        } @else {
          {{ data.siteName }}
        }
      } @else if (vm().isLoading) {
        <app-loading-skeleton class="w-[110px] h-[20px]" viewBox="0 0 110 20">
          <svg:rect x="0" y="0" rx="5" ry="5" width="110px" height="20px" />
        </app-loading-skeleton>
      }
    </div>

    <app-table-cell-sortable-header
      *appTableCellHeader="let data; key: 'type'; cellWidth: severityColumnIsShown() ? '17%' : '22%'"
      [title]="'shared.alerting-table.type' | translate"
      [sortDirection]="vm().sortProperty === AlertingTableSortPropertyStoreModelEnum.Type ? vm().sortDirection : undefined"
      (sortClick)="onSortClick(AlertingTableSortPropertyStoreModelEnum.Type, $event)"
    ></app-table-cell-sortable-header>

    <div *appTableCell="let data; key: 'type'; dataSource: dataSource" class="pr-2">
      @if (hasData) {
        {{ getTypeAsAlertType(data.type) | appTranslateAlertType }}
      } @else if (vm().isLoading) {
        <app-loading-skeleton class="w-[110px] h-[20px]" viewBox="0 0 110 20">
          <svg:rect x="0" y="0" rx="5" ry="5" width="110px" height="20px" />
        </app-loading-skeleton>
      }
    </div>

    <app-table-cell-sortable-header
      *appTableCellHeader="let data; key: 'subject'; cellWidth: severityColumnIsShown() ? '18%' : actionsColumnIsShown() ? '23%' : '28%'"
      [title]="'shared.alerting-table.subject' | translate"
      [sortDirection]="vm().sortProperty === AlertingTableSortPropertyStoreModelEnum.Subject ? vm().sortDirection : undefined"
      (sortClick)="onSortClick(AlertingTableSortPropertyStoreModelEnum.Subject, $event)"
    ></app-table-cell-sortable-header>

    <div *appTableCell="let data; key: 'subject'; dataSource: dataSource" class="pr-2">
      @if (hasData) {
        @if (data.chargerId && data.chargerName) {
          <a [routerLink]="['/', RouteSegment.Sites, data.siteId, RouteSegment.Chargers, RouteSegment.ChargerDetails, data.chargerId]">
            <app-table-view-link [label]="data.evseName ? data.chargerName + '/' + data.evseName : data.chargerName"></app-table-view-link>
          </a>
        } @else {
          {{ data.subject }}
        }
      } @else if (vm().isLoading) {
        <app-loading-skeleton class="w-[110px] h-[20px]" viewBox="0 0 110 20">
          <svg:rect x="0" y="0" rx="5" ry="5" width="110px" height="20px" />
        </app-loading-skeleton>
      }
    </div>

    <app-table-cell-sortable-header
      *appTableCellHeader="let data; key: 'timestamp'; cellWidth: actionsColumnIsShown() ? '10%' : '15%'"
      [ngClass]="[createdAtRightAligned() ? 'text-right' : 'pr-2']"
      [title]="'shared.alerting-table.created-at' | translate"
      [sortDirection]="vm().sortProperty === AlertingTableSortPropertyStoreModelEnum.Timestamp ? vm().sortDirection : undefined"
      (sortClick)="onSortClick(AlertingTableSortPropertyStoreModelEnum.Timestamp, $event)"
    ></app-table-cell-sortable-header>

    <div *appTableCell="let data; key: 'timestamp'; dataSource: dataSource" [ngClass]="[createdAtRightAligned() ? 'text-right' : '']">
      @if (hasData) {
        <app-site-date-time [value]="data.timestamp" [timeZone]="tenantsStore.siteTimeZones().get(data.siteId ?? '')" format="time" />
      } @else if (vm().isLoading) {
        <app-loading-skeleton class="w-[60px] h-[20px]" viewBox="0 0 60 20">
          <svg:rect x="0" y="0" rx="5" ry="5" width="60px" height="20px" />
        </app-loading-skeleton>
      }
    </div>

    @if (severityColumnIsShown()) {
      <app-table-cell-sortable-header
        *appTableCellHeader="let data; key: 'severity'; cellWidth: '10%'"
        [title]="'shared.alerting-table.severity' | translate"
        [sortDirection]="vm().sortProperty === AlertingTableSortPropertyStoreModelEnum.Severity ? vm().sortDirection : undefined"
        (sortClick)="onSortClick(AlertingTableSortPropertyStoreModelEnum.Severity, $event)"
      ></app-table-cell-sortable-header>

      <div *appTableCell="let data; key: 'severity'; dataSource: dataSource">
        @if (hasData) {
          @if (data.severity) {
            <app-table-status-cell [properties]="tableStatusCellProperties" [status]="data.severity" />
          }
        } @else if (vm().isLoading) {
          <app-loading-skeleton class="w-[50px] h-[20px]" viewBox="0 0 50 20">
            <svg:rect x="0" y="0" rx="5" ry="5" width="50px" height="20px" />
          </app-loading-skeleton>
        }
      </div>
    }

    @if (!sopColumnIsHidden()) {
      <div *appTableCellHeader="let data; key: 'sop'; cellWidth: '8%'"></div>

      <div *appTableCell="let data; key: 'sop'; dataSource: dataSource">
        @if (hasData) {
          @if (data.sopUrl) {
            <a [href]="data.sopUrl" target="_blank" rel="noopener noreferrer">
              <app-table-view-link label="SOP" />
            </a>
          }
        } @else if (vm().isLoading) {
          <app-loading-skeleton class="w-[40px] h-[20px]" viewBox="0 0 40 20">
            <svg:rect x="0" y="0" rx="5" ry="5" width="40px" height="20px" />
          </app-loading-skeleton>
        }
      </div>
    }

    @if (dismissedReasonColumnIsShown()) {
      <div *appTableCellHeader="let data; key: 'dismissedReason'; cellWidth: '5%'"></div>

      <div *appTableCell="let data; key: 'dismissedReason'; dataSource: dataSource">
        @if (hasData) {
          @if (data.dismissedReason) {
            <svg-icon key="info-16" [appPopover]="data.dismissedReason" position="top-middle"></svg-icon>
          }
        } @else if (vm().isLoading) {
          <app-loading-skeleton class="w-[20px] h-[20px]" viewBox="0 0 20 20">
            <svg:rect x="0" y="0" rx="5" ry="5" width="20px" height="20px" />
          </app-loading-skeleton>
        }
      </div>
    }

    @if (actionsColumnIsShown()) {
      <div *appTableCellHeader="let data; key: 'actions'; cellWidth: '10%'"></div>

      <div *appTableCell="let data; key: 'actions'; dataSource: dataSource" class="flex justify-end items-center">
        @if (hasData) {
          <app-button type="secondary-v2" (clickEvent)="onActionClick(data)">
            {{ actionButtonLabel() }}
          </app-button>
        } @else if (vm().isLoading) {
          <app-loading-skeleton class="w-[80px] h-[20px]" viewBox="0 0 80 20">
            <svg:rect x="0" y="0" rx="5" ry="5" width="80px" height="20px" />
          </app-loading-skeleton>
        }
      </div>
    }
  </app-table>
} @else {
  <span class="text-sm">{{ 'shared.alerting-table.empty-table' | translate }}</span>
}
